export { Button, ButtonRoot } from './Button';
export { LinkButton, LinkButtonRoot } from './LinkButton';
export { ProgressButton, ProgressButtonSpinner } from './ProgressButton';
export { toBlenderProps } from './blenderMapping';
export { TextWrapper } from './buttonStyle';
export { buttonTheme } from './buttonTheme';
if (window?.location.hostname.includes('localhost') ||
    window?.location.hostname.includes('staging')) {
    console.warn('Old Button is deprecated and will be removed in the future. Please use Button from @clds/button instead.');
}
//# sourceMappingURL=index.js.map